import { AddressData } from '@/models/UserAddress';

export function formatAddressText(addressData: AddressData) {
  return `${addressData.address || ''}${
    addressData.neighborhood ? ` ${addressData.neighborhood}` : ''
  }${addressData.district ? ` ${addressData.district}` : ''}${
    addressData.city ? ` / ${addressData.city}` : ''
  }`;
}

export function formatAddressSearchText(addressData: AddressData, label?: string | null) {
  return [
    label,
    addressData.title,
    addressData.phoneNumber,
    addressData.address,
    addressData.city,
    addressData.district,
    addressData.neighborhood,
    addressData.companyName,
  ]
    .filter(Boolean)
    .join(' ')
    .toLocaleLowerCase('tr-TR');
}
